import { axiosInstance } from '@/plugins/Api';
import { mapViewNameToJsonContent } from '@/utils/content';

// const PATH_TO_CONTENT_FILES = '../store/content/texts';

const contentApi = {
  getContent() {
    return axiosInstance.get('/content');
  },
};

function getContentFromJson(viewName) {
  return mapViewNameToJsonContent(viewName);
}

const fakeApi = {

};

export {
  contentApi,
  fakeApi,
  getContentFromJson,
};
